import { useCallback, useEffect, useRef, useState } from "react";

import * as api from "../api";

export const useTableRequest = (id, enabled) => {
  const [request, setRequest] = useState(null);
  const [state, setState] = useState("loading");
  const currentId = useRef(id);

  useEffect(() => {
    currentId.current = id;
    setRequest(null);
    setState("loading");
    return () => {
      currentId.current = null;
    };
  }, [id]);

  const reload = useCallback(() => {
    const isCurrent = () => currentId.current === id;
    return api.tableRequests
      .getTableRequest(id)
      .then((response) => {
        if (!isCurrent()) return;
        setRequest(response.data);
        setState("ready");
      })
      .catch((error) => {
        if (!isCurrent()) return;
        if (error?.response?.status === 404) {
          setState("not_found");
          return;
        }
        setState((current) => (current === "ready" ? current : "error"));
      });
  }, [id]);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { request, state, reload };
};
